import { Injectable } from "@angular/core";
import { EnvironmentStore } from "./environment.store";
import { EnvironmentState } from "./environment.state";
import { select } from "@ngneat/elf";
import { map } from "rxjs";

@Injectable({ providedIn: "root" })
export class EnvironmentQuery {
	constructor(private environmentStore: EnvironmentStore) {}

	readonly configurations: BackEndConfiguration[] = [
		{
			environment: EnvironmentState.Development,
			name: "Development",
			api: {
				url: "http://localhost:5055/",
			},
			frontEnd: {
				url: "http://localhost:5001/",
			},
		},
		{
			environment: EnvironmentState.Staging,
			name: "Staging",
			api: {
				url: "https://app.staging.mobaro.com/",
			},
			frontEnd: {
				url: "https://app.staging.mobaro.com/",
			},
		},
		{
			environment: EnvironmentState.Production,
			name: "Production",
			api: {
				url: "https://app.mobaro.com/",
			},
			frontEnd: {
				url: "https://app.mobaro.com/",
			},
		},
	];

	getAvailableEnvironments = () => {
		return this.configurations.map((config) => {
			return { id: config.environment, name: config.name };
		});
	};

	environment$ = this.environmentStore.store.pipe(
		select((state) => state),
		map((state) => {
			return this.configurations[state.environment];
		}),
	);
}

export interface BackEndConfiguration {
	environment: EnvironmentState;
	name: string;
	api: {
		url: string;
	};
	frontEnd: {
		url: string;
	};
}
